// src/App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import WritePage from "./pages/WritePage";
import EntryPage from "./pages/EntryPage";
import MyPlant from "./pages/MyPlant";
import GoalsPage from "./pages/GoalsPage";
import ChatPage from "./pages/ChatPage";
import ProgressPage from "./pages/ProgressPage";
import WorkoutPage from "./pages/WorkoutPage";
import MealPage from "./pages/MealPage";
import "./App.css";
import Dashboard from "./pages/Dashboard";
import LoginPage from "./pages/LoginPage";
import ProtectedRoute from "./components/ProtectedRoute/ProtectedRoute"; // Import the ProtectedRoute component
import './mobile.css'
import TOSPage from "./pages/TOSPage";
import PrivacyPage from "./pages/PrivacyPage";
import TrainMindPage from "./pages/TrainMindPage";
import TrainMindEntriesPage from "./pages/TrainMindEntriesPage";
import OnboardingPage from "./pages/OnboardingPage";
import ProfilePage from "./pages/ProfilePage";
import LoadingPage from "./pages/LoadingPage";
import CoachDashboard from "./pages/CoachDashboard";
import CoachMemberPage from "./pages/CoachMemberPage";
import PlanSelectionPage from "./pages/PlanSelectionPage";
import PaymentSuccessPage from "./pages/PaymentSuccessPage";
import PaymentCancelPage from "./pages/PaymentCancelPage";

function App() {
  return (
    <Router>
      <Routes>
        {/* Public Routes */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/terms-of-service" element={<TOSPage />} />
        <Route path="/privacy-policy" element={<PrivacyPage />} />
        <Route path="/loading" element={<LoadingPage />} />
        <Route
          path="/select-plan"
          element={
            <ProtectedRoute>
              <PlanSelectionPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/payment/success"
          element={
            <ProtectedRoute>
              <PaymentSuccessPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/payment/cancel"
          element={
            <ProtectedRoute>
              <PaymentCancelPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/onboarding"
          element={
            <ProtectedRoute>
              <OnboardingPage />
            </ProtectedRoute>
          }
        />

        {/* Protected Routes */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/write"
          element={
            <ProtectedRoute>
              <WritePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/entries"
          element={
            <ProtectedRoute>
              <EntryPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/my-plant"
          element={
            <ProtectedRoute>
              <MyPlant />
            </ProtectedRoute>
          }
        />
        <Route
          path="/my-goals"
          element={
            <ProtectedRoute>
              <GoalsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/progress"
          element={
            <ProtectedRoute>
              <ProgressPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/workout"
          element={
            <ProtectedRoute>
              <WorkoutPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/meals"
          element={
            <ProtectedRoute>
              <MealPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/chat"
          element={
            <ProtectedRoute>
              <ChatPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/profile"
          element={
            <ProtectedRoute>
              <ProfilePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/coach"
          element={
            <ProtectedRoute>
              <CoachDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/coach/members/:memberId"
          element={
            <ProtectedRoute>
              <CoachMemberPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/train-mind"
          element={
            <ProtectedRoute>
              <TrainMindPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/train-mind/entries"
          element={
            <ProtectedRoute>
              <TrainMindEntriesPage />
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
